export var AutoCompleteType;
(function (AutoCompleteType) {
    /** The browser is not permitted to automatically enter or select a value for this field */
    AutoCompleteType["Off"] = "off";
    /** The browser is allowed to automatically complete the input */
    AutoCompleteType["On"] = "on";
    /** The field expects the value to be a person's full name */
    AutoCompleteType["Name"] = "name";
    /** The prefix or title, such as "Mrs.", "Mr.", "Miss", "Ms.", "Dr.", or "Mlle." */
    AutoCompleteType["HonorificPrefix"] = "honorific-prefix";
    /** The given (or "first") name. */
    AutoCompleteType["GivenName"] = "given-name";
    /** The middle name */
    AutoCompleteType["AdditionalName"] = "additional-name";
    /** The family (or "last") name */
    AutoCompleteType["FamilyName"] = "family-name";
    /** The suffix, such as "Jr.", "B.Sc.", "PhD.", "MBASW", or "IV". */
    AutoCompleteType["HonorificSuffix"] = "honorific-suffix";
    /** A nickname or handle */
    AutoCompleteType["Nickname"] = "nickname";
    /** An email address */
    AutoCompleteType["Email"] = "email";
    /** A username or account name */
    AutoCompleteType["Username"] = "username";
    /** A new password */
    AutoCompleteType["NewPassword"] = "new-password";
    /** The user's current password */
    AutoCompleteType["CurrentPassword"] = "current-password";
    /** A one-time code used for verifying user identity */
    AutoCompleteType["OneTimeCode"] = "one-time-code";
    /** A job title, or the title a person has within an organization */
    AutoCompleteType["OrganizationTitle"] = "organization-title";
    /** A company or organization name */
    AutoCompleteType["Organization"] = "organization";
    /** A street address */
    AutoCompleteType["StreetAddress"] = "street-address";
    /** Each individual line of the street address. These should only be present if the "street-address" is also present */
    AutoCompleteType["AddressLine1"] = "address-line1";
    AutoCompleteType["AddressLine2"] = "address-line2";
    AutoCompleteType["AddressLine3"] = "address-line3";
    /** The finest-grained administrative level, in addresses which have four levels */
    AutoCompleteType["AddressLevel4"] = "address-level4";
    /** The third administrative level, in addresses with at least three administrative levels */
    AutoCompleteType["AddressLevel3"] = "address-level3";
    /** The second administrative level, in addresses with at least two of them. In countries with two administrative levels, this would typically be the city, town, village, or other locality in which the address is located */
    AutoCompleteType["AddressLevel2"] = "address-level2";
    /** The first administrative level in the address. This is typically the province in which the address is located. In the United States, this would be the state. In Switzerland, the canton. In the United Kingdom, the post town */
    AutoCompleteType["AddressLevel1"] = "address-level1";
    /** A country code */
    AutoCompleteType["Country"] = "country";
    /** A country name */
    AutoCompleteType["CountryName"] = "country-name";
    /** A postal code */
    AutoCompleteType["PostalCode"] = "postal-code";
    /** The full name as printed on or associated with a payment instrument such as a credit card */
    AutoCompleteType["CcName"] = "cc-name";
    /** A given (first) name as given on a payment instrument like a credit card */
    AutoCompleteType["CcGivenName"] = "cc-given-name";
    /** A middle name as given on a payment instrument or credit card */
    AutoCompleteType["CcAdditionalName"] = "cc-additional-name";
    /** A family name, as given on a credit card */
    AutoCompleteType["CcFamilyName"] = "cc-family-name";
    /** A credit card number or other number identifying a payment method, such as an account number */
    AutoCompleteType["CcNumber"] = "cc-number";
    /** A payment method expiration date, typically in the form "MM/YY" or "MM/YYYY" */
    AutoCompleteType["CcExp"] = "cc-exp";
    /** The month in which the payment method expires */
    AutoCompleteType["CcExpMonth"] = "cc-exp-month";
    /** The year in which the payment method expires */
    AutoCompleteType["CcExpYear"] = "cc-exp-year";
    /** The security code for the payment instrument; on credit cards, this is the 3-digit verification number on the back of the card */
    AutoCompleteType["CcCsc"] = "cc-csc";
    /** The type of payment instrument (such as "Visa" or "Master Card") */
    AutoCompleteType["CcType"] = "cc-type";
    /** The currency in which the transaction is to take place */
    AutoCompleteType["TransactionCurrency"] = "transaction-currency";
    /** The amount, given in the currency specified by "transaction-currency", of the transaction, for a payment form */
    AutoCompleteType["TransactionAmount"] = "transaction-amount";
    /** A preferred language */
    AutoCompleteType["Language"] = "language";
    /** A birth date, as a full date */
    AutoCompleteType["Bday"] = "bday";
    /** The day of the month of a birth date */
    AutoCompleteType["BdayDay"] = "bday-day";
    /** The month of the year of a birth date */
    AutoCompleteType["BdayMonth"] = "bday-month";
    /** The year of a birth date */
    AutoCompleteType["BdayYear"] = "bday-year";
    /** A gender identity (such as "Female", "Fa'afafine", "Male"), as freeform text without newlines */
    AutoCompleteType["Sex"] = "sex";
    /** A full telephone number, including the country code */
    AutoCompleteType["Tel"] = "tel";
    /** The country code */
    AutoCompleteType["TelCountryCode"] = "tel-country-code";
    /** The entire phone number without the country code component, including a country-internal prefix. For the phone number "1-855-555-6502", this field's value would be "855-555-6502" */
    AutoCompleteType["TelNational"] = "tel-national";
    /** The area code, with any country-internal prefix applied if appropriate */
    AutoCompleteType["TelAreaCode"] = "tel-area-code";
    /** The phone number without the country or area code */
    AutoCompleteType["TelLocal"] = "tel-local";
    /** A telephone extension code within the phone number, such as a room or suite number in a hotel or an office extension in a company */
    AutoCompleteType["TelExtension"] = "tel-extension";
    /** A URL for an instant messaging protocol endpoint */
    AutoCompleteType["Impp"] = "impp";
    /** A URL, such as a home page or company web site address as appropriate given the context of the other fields in the form */
    AutoCompleteType["Url"] = "url";
    /** The URL of an image representing the person, company, or contact information given in the other fields in the form */
    AutoCompleteType["Photo"] = "photo";
})(AutoCompleteType || (AutoCompleteType = {}));
//# sourceMappingURL=auto-complete-type.js.map